<template>
  <v-checkbox
    v-model="localValue"
    class="mt-0 ml-1"
    :label="title"
    :rules="rules"
    :readonly="readOnly"
  >
    <template #label>
      <div v-text="title" />
    </template>
  </v-checkbox>
</template>

<script>
import { mixinFormItemGeneric } from '../mixins/mixin-form-item-generic'

export default {
  mixins: [mixinFormItemGeneric],
}
</script>
